import React, { Component } from "react";
import { createRoot } from "react-dom/client";
import ThemeProviderWrapper from "../hoc/ThemeProviderWrapper";
import { Box, Container, Typography } from "@mui/material";
import "../styles/global.css";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import GridContent from "../components/Grid/GridContent";
import SearchBar from "../components/SearchBar/SearchBar";
import CarouselWidget from "../components/CarouselWidget/CarouselWidget";
import ClientConfigurationHelper from "../configuration/ClientConfigurationHelper";

TVSite.isHomePage = true;

class Home extends Component {
    state = {
        loaded: true,
        category: "",
        total: 0,
        sort: "most_recent",
    };
    updateRequestParameter = (searchTerm, category, sort, section) => {
        this.setState({ loaded: false });
        if (category) {
            this.setState({ category: category, total: "-" });
        }
        if (sort) {
            this.setState({ sort: sort });
        }
        setTimeout(() => {
            this.setState({ loaded: true });
        }, 300);
    };
    resetRequestParameter = () => {
        this.setState({ loaded: false, category: "", sort: "most_recent" });
        setTimeout(() => {
            this.setState({ loaded: true });
        }, 300);
    };
    setTotal = (total) => {
        this.setState({ total: total });
    };
    render() {
        const { dependency_root } = ClientConfigurationHelper.getGlobalConfiguration();
        const bannerDesktop = dependency_root + "static/images/aero_new_banner_desktop.png";
        const bannerMobile = dependency_root + "static/images/aero_new_banner_mobile.png";
        return (
            <ThemeProviderWrapper>
                <Breadcrumbs keepOnMobile />
                <Container></Container>
                <Container>
                    <Box>
                        <Box
                            sx={{
                                backgroundImage: {
                                    xs: `url(${bannerMobile})`,
                                    sm: `url(${bannerDesktop})`,
                                },
                                backgroundPosition: "center",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                height: {
                                    xs: "258px",
                                    sm: "200px",
                                },
                            }}
                        ></Box>
                    </Box>
                    <Box>
                        <CarouselWidget />
                    </Box>
                </Container>
                <SearchBar
                    total={this.state.total}
                    updateSearchResults={this.updateRequestParameter}
                    resetRequestParameter={this.resetRequestParameter}
                />
                {this.state.loaded && (
                    <GridContent
                        gridTitle={" "}
                        redirect={false}
                        query={""}
                        setTotal={this.setTotal}
                        sort={this.state.sort}
                        category={this.state.category}
                        contentTitle={""}
                        search_tag={""}
                        creator_id={""}
                    />
                )}
            </ThemeProviderWrapper>
        );
    }
}

export default Home;

const targetEl = document.getElementById("app-container");

if (targetEl) {
    const root = createRoot(targetEl);
    root.render(<Home />);
}
